import React, { useMemo } from 'react';
import DataGrid from '../../common/DataGrid';

/**
 * Category grid — column definitions only.
 * Before: 104 lines.  After: ~20 lines.
 */
export default function CategoryGrid(props) {
  const columns = useMemo(
    () => [
      { field: 'category_id', headerName: 'ID', maxWidth: 100, flex: 0 },
      { field: 'category_name', headerName: 'Category Name', flex: 1 },
    ],
    []
  );

  return (
    <DataGrid
      {...props}
      columns={columns}
      exportFileName="category_data.csv"
    />
  );
}
